import styled, { css } from 'styled-components';
import { IconButton } from '@mui/material';

export {
  TreeItem,
  LabelWrapper,
  TextWrapper,
  Code,
  Name,
} from '../../organization/organizationItem/OrganizationItem.styles';

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionWrapper = styled.span`
  display: inline-flex;
`;

export const DeleteButton = styled(IconButton)(
  ({ theme: { palette } }) => css`
    width: 32px;
    height: 32px;
    border-radius: 8px;
    padding: 4px;

    svg {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
    }

    &.Mui-disabled path {
      fill: ${palette.grey[600]};
    }
  `,
);

export const AddButton = styled(IconButton)(
  ({ theme: { palette } }) => css`
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background-color: #eff0f5;

    &.Mui-disabled {
      background-color: #eff0f5;

      path {
        fill: ${palette.grey[600]};
      }
    }
  `,
);
